export default __webpack_public_path__ + "static/media/nwabueze.46b21bb7.png";